import { CheckBox, StyledCheckBox } from "@animech/ui";
import { css } from "@emotion/react";
import styled from "@emotion/styled";

export const Container = styled.figure``;
export const Label = styled.figcaption``;
export const Group = styled.ul``;
export const Item = styled.li``;
export const Toggle = styled(CheckBox)``;

export const Root = styled.div`
	${({ theme }) => {
		return css`
			background-color: ${theme.colors.backgrounds[2].background};

			${Container} {
				display: flex;
				flex-direction: row;
				align-items: center;
				margin: 0 ${theme.dimensions.margin.small};
			}

			${Group} {
				display: flex;
				flex-direction: row;
				align-items: center;
				list-style-type: none;
				gap: ${theme.dimensions.margin.base};
			}

			${Item} {
				margin: 0;
			}

			${Toggle} {
				&[data-checked="true"] {
					background-color: ${theme.colors.backgrounds[3].background};

					${StyledCheckBox.Label} {
						color: ${theme.colors.foregrounds[3]} !important;
					}
				}

				${StyledCheckBox.CheckedIcon},
				${StyledCheckBox.IndeterminateIcon} {
					display: none;
				}

				${StyledCheckBox.Label} {
					color: ${theme.colors.foregrounds[5]} !important;
					margin: ${theme.dimensions.margin.xxSmall}
						${theme.dimensions.margin.base};
				}
			}
		`;
	}}
`;
